import React, { useEffect } from 'react'
import { AiOutlineCloseCircle } from 'react-icons/ai'


const Modal = ({ show, setshow, children }) => {
  useEffect(() => {
    show ? document.body.classList.add('modal-active') : document.body.classList.remove('modal-active')

  }, [show])
  return (
    <div id='modal-container' className={`${show ? 'one' : 'out'}`}>
        <div className="modal-background">
        <AiOutlineCloseCircle className='close' onClick={() => {setshow(false)}}/>
          <div className="modal">
            <div className="modal-body">
              {children}
            </div>
          </div>
        </div>
      </div>
    )
}

export default Modal